import type { ICreateSendSettingsState } from '../types/createSendSettings';
import type { ShippingOptionsEnum } from '../types/shipping';

const GROUND = 'ground' as ShippingOptionsEnum;

export const DEFAULT_CREATE_SEND_SETTINGS_STATE: ICreateSendSettingsState = {
  internalNotes: '',
  businessReasonId: '',
  onHoldEnabled: false,
  onHoldUntil: '',
  claimExpiration: '',
  claimExpirationTimezone: null,
  sobEnabled: false,
  sobEmail: null,
  disableSenderEmails: true,
  isSenderEmailsTouched: false,
  disableRecipientShippedEmail: false,
  shippingOption: GROUND,
  isOfficeDropshipEnabled: false,
};
